import { render, staticRenderFns } from "./LetterConfirmCard.vue?vue&type=template&id=fff6b434"
import script from "./LetterConfirmCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LetterConfirmCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports